var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Configuration as Configuration } from "../configuration";
import { V1Api, V2Api, V3Api } from "../api";
import { getProcessEnv, setErrorInterceptor } from "./utils";
export let GENTRACE_API_KEY = "";
export function getGentraceApiKey() {
    return GENTRACE_API_KEY;
}
export let GENTRACE_BASE_PATH = "";
export function getGentraceBasePath() {
    return GENTRACE_BASE_PATH;
}
export let GENTRACE_BRANCH = "";
export let GENTRACE_COMMIT = "";
export let GENTRACE_SHOW_CONNECTION_ERRORS = "";
// @deprecated: use GENTRACE_RESULT_NAME instead
export let GENTRACE_RUN_NAME = "";
export let GENTRACE_RESULT_NAME = "";
export let GENTRACE_ENVIRONMENT_NAME = "";
export let globalGentraceConfig = null;
export let globalGentraceApi = null;
export let globalGentraceApiV2 = null;
export let globalGentraceApiV3 = null;
export let globalRequestBuffer = {};
export let resetGlobalGentraceApi = () => {
    globalGentraceConfig = null;
};
export function init(values) {
    const { apiKey, basePath, branch, commit, showConnectionErrors, runName, resultName, environmentName, } = values !== null && values !== void 0 ? values : {};
    if (!apiKey && !getProcessEnv("GENTRACE_API_KEY")) {
        throw new Error("Gentrace API key was provided neither by the `apiKey` param in the constructor nor by the `GENTRACE_API_KEY` env variable.");
    }
    GENTRACE_API_KEY = apiKey || getProcessEnv("GENTRACE_API_KEY");
    GENTRACE_RUN_NAME = runName || getProcessEnv("GENTRACE_RUN_NAME");
    GENTRACE_RESULT_NAME = resultName || getProcessEnv("GENTRACE_RESULT_NAME");
    GENTRACE_ENVIRONMENT_NAME =
        environmentName || getProcessEnv("GENTRACE_ENVIRONMENT_NAME");
    GENTRACE_SHOW_CONNECTION_ERRORS =
        showConnectionErrors || getProcessEnv("GENTRACE_SHOW_CONNECTION_ERRORS");
    setErrorInterceptor();
    if (basePath) {
        try {
            const url = new URL(basePath);
            if (url.pathname.startsWith("/api")) {
            }
            else {
                throw new Error('Gentrace base path must end in "/api".');
            }
        }
        catch (err) {
            throw new Error(`Invalid Gentrace base path (${basePath}): ${err.message}`);
        }
        GENTRACE_BASE_PATH = basePath;
    }
    globalGentraceConfig = new Configuration({
        apiKey: GENTRACE_API_KEY,
        basePath: GENTRACE_BASE_PATH,
    });
    globalGentraceApi = new V1Api(globalGentraceConfig);
    globalGentraceApiV2 = new V2Api(globalGentraceConfig);
    globalGentraceApiV3 = new V3Api(globalGentraceConfig);
    if (branch) {
        GENTRACE_BRANCH = branch;
    }
    if (commit) {
        GENTRACE_COMMIT = commit;
    }
}
export function deinit() {
    GENTRACE_API_KEY = "";
    GENTRACE_BASE_PATH = "";
    GENTRACE_BRANCH = "";
    GENTRACE_COMMIT = "";
    GENTRACE_SHOW_CONNECTION_ERRORS = "";
    globalGentraceConfig = null;
    globalGentraceApi = null;
    globalGentraceApiV2 = null;
    globalGentraceApiV3 = null;
    globalRequestBuffer = {};
}
export function flush() {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield Promise.allSettled(Object.values(globalRequestBuffer))).every((result) => result.status === "fulfilled");
    });
}
